export default function AutosaveField({ label, value, onChange, multiline = false, placeholder, testId }) {
  const Tag = multiline ? "textarea" : "input";
  return (
    <div className="mb-1">
      {label && <label className="text-sm font-medium text-ink block mb-1.5">{label}</label>}
      <Tag
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={multiline ? 4 : undefined}
        data-testid={testId}
        className="w-full rounded-lg border border-ink/15 bg-white/60 px-3 py-2 text-sm text-ink placeholder:text-ink-soft/50 focus:outline-none focus:ring-2 focus:ring-terracotta/40 transition-shadow"
      />
    </div>
  );
}
